module.exports = __webpack_public_path__ + "img/poki.0efb298c.jpg";